import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Business } from "interfaces/business";
import { BusinessCreatorFavorite } from "interfaces/business-creator-favorite";
import { Escrow } from "interfaces/escrow";
import { Subscription } from "interfaces/subscription";
import {
  fetchBusinessEscrow,
  fetchFavoritedCreators,
  getBusinessById,
  getBusinessesLoggedUser,
  getSubscriptionInfo,
} from "services/SauceService";

export const getBusinessInfo = createAsyncThunk(
  "business/getBusinessInfo",
  async () => {
    const businessId = localStorage.getItem("businessId");
    if (!businessId) {
      return {};
    }
    const businessInfo: any = await getBusinessById(businessId);
    return businessInfo;
  }
);

export const getBusinessess = createAsyncThunk(
  "business/getBusinesses",
  async () => {
    const businesses: any = await getBusinessesLoggedUser();
    return businesses;
  }
);

export const getBusinessSubscription = createAsyncThunk(
  "business/getBusinessSubscription",
  async (includeStripeDetails?: boolean) => {
    const businessId = localStorage.getItem("businessId");
    if (!businessId) {
      return {};
    }

    const subscription: any = await getSubscriptionInfo({
      businessId,
      includeStripeDetails,
    });
    return subscription;
  }
);

export const getBusinessEscrow = createAsyncThunk(
  "business/getBusinessEscrow",
  async (includeStatement?: boolean) => {
    const businessId = localStorage.getItem("businessId");
    if (!businessId) {
      return {};
    }
    const escrow: any = await fetchBusinessEscrow({
      businessId,
      includeStatement,
    });
    return escrow;
  }
);

export const getFavoritedCreators = createAsyncThunk(
  "business/getFavoritedCreators",
  async () => {
    const businessId = localStorage.getItem("businessId");
    if (!businessId) {
      return {};
    }
    const creators: any = await fetchFavoritedCreators({ businessId });
    return creators;
  }
);

export type BusinessState = {
  business: {
    loading: boolean;
    loadingBusinessess: boolean;
    business: Business;
    subscription: Subscription;
    businessess: any[];
    escrow: Escrow;
    favoritedCreators: BusinessCreatorFavorite[];
  };
};

export const businessSlice: any = createSlice({
  name: "business",
  initialState: {
    loading: true,
    loadingBusinessess: true,
    business: {},
    subscription: {},
    businessess: [],
    escrow: {},
    favoritedCreators: [],
  },
  reducers: {
    setBusiness: (state, action) => {
      state.businessess = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBusinessInfo.fulfilled, (state, action) => {
      if (action.payload) {
        state.business = action.payload;
      }
      state.loading = false;
    });

    builder.addCase(getBusinessInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getBusinessess.pending, (state) => {
      state.loadingBusinessess = true;
    });

    builder.addCase(getBusinessess.fulfilled, (state, action) => {
      state.businessess = action.payload;
      state.loadingBusinessess = false;
    });

    builder.addCase(getBusinessSubscription.fulfilled, (state, action) => {
      state.subscription = action.payload;
      state.loading = false;
    });

    builder.addCase(getBusinessEscrow.fulfilled, (state, action) => {
      state.escrow = action.payload;
      state.loading = false;
    });

    builder.addCase(getFavoritedCreators.fulfilled, (state, action) => {
      if (action.payload) {
        state.favoritedCreators = action.payload?.favorites || [];
      }
      state.loading = false;
    });

    builder.addCase(getFavoritedCreators.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setBusiness } = businessSlice.actions;

export default businessSlice.reducer;
